"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var PropTypes = require("prop-types");
var classnames_1 = require("../util/classnames");
var vdl_prefix_1 = require("../util/vdl-prefix");
var _1 = require("../util/_");
var secondary_nav_1 = require("../secondary-nav");
var mega_menu_popover_1 = require("./mega-menu-popover");
var dom_helpers_1 = require("../util/dom-helpers");
var angle_down_1 = require("adp-react-icons/lib/fa/angle-down");
var MegaMenu = /** @class */ (function (_super) {
    __extends(MegaMenu, _super);
    function MegaMenu() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            activeIndex: 0
        };
        _this.close = function () {
            if (_this.state.activeSubmenu) {
                _this.setState({
                    activeSubmenu: null
                });
            }
        };
        _this.handleWindowResize = function () {
            _this.close();
        };
        _this.handleMenuClick = function (activeIndex) {
            var _a = _this.props, config = _a.config, onSelected = _a.onSelected;
            var activeSubmenu = config[activeIndex].submenus ? config[activeIndex].submenus[0] : null;
            // We need setTimeout to postpone setState() because handleRootClose() needs to happen first
            setTimeout(function () {
                _this.setState({
                    activeIndex: activeIndex,
                    activeSubmenu: activeSubmenu
                });
                if (!activeSubmenu) {
                    onSelected(config[activeIndex]);
                }
            });
        };
        _this.handleSubmenuClick = function (activeSubmenu) {
            _this.setState({
                activeSubmenu: activeSubmenu
            });
        };
        _this.handleItemClick = function (activeItem) {
            _this.close();
            _this.props.onSelected(activeItem);
        };
        _this.handleRootClose = function () {
            _this.setState({
                activeItem: undefined,
                activeSubmenu: undefined
            });
        };
        _this.renderMegaMenuPopover = function () {
            var config = _this.props.config;
            var activeSubmenu = _this.state.activeSubmenu;
            var activeIndex = _this.state.activeIndex;
            if (!activeSubmenu) {
                return;
            }
            return (React.createElement(mega_menu_popover_1.MegaMenuPopover, { targetId: "mega-menu-nav-item-" + activeIndex, config: config[activeIndex], activeSubmenu: activeSubmenu, onSubmenuClick: _this.handleSubmenuClick, onItemClick: _this.handleItemClick, onRootClose: _this.handleRootClose }));
        };
        return _this;
    }
    MegaMenu.prototype.componentDidMount = function () {
        dom_helpers_1.on(window, 'resize', this.handleWindowResize);
    };
    MegaMenu.prototype.componentWillUnmount = function () {
        dom_helpers_1.off(window, 'resize', this.handleWindowResize);
    };
    MegaMenu.prototype.render = function () {
        var _a;
        var _b = this.props, className = _b.className, config = _b.config;
        var _c = this.state, activeIndex = _c.activeIndex, activeSubmenu = _c.activeSubmenu;
        var customProps = _1.omit(this.props, Object.keys(MegaMenu.propTypes));
        var rootClasses = (_a = {},
            _a[vdl_prefix_1.vdlPrefix('mega-menu')] = true,
            _a[vdl_prefix_1.vdlPrefix('mega-menu--open')] = !!activeSubmenu,
            _a);
        return (React.createElement("div", __assign({}, customProps, { className: classnames_1.classNames(className, rootClasses) }),
            React.createElement(secondary_nav_1.SecondaryNav, { activeIndex: activeIndex, onChange: this.handleMenuClick }, config.map(function (navItem, index) { return (React.createElement(secondary_nav_1.SecondaryNavItem, { key: index, id: "mega-menu-nav-item-" + index },
                navItem.label,
                navItem.submenus
                    ? React.createElement(angle_down_1.default, { className: vdl_prefix_1.vdlPrefix('mega-menu-nav-item__icon') })
                    : undefined)); })),
            this.renderMegaMenuPopover()));
    };
    MegaMenu.propTypes = {
        className: PropTypes.string,
        config: PropTypes.array.isRequired,
        onSelected: PropTypes.func.isRequired
    };
    return MegaMenu;
}(React.Component));
exports.MegaMenu = MegaMenu;
